/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, February 2022
 * @format
 * @flow
 */

import React from 'react';
import PropTypes from 'prop-types';
import classes from './Divider.module.css';

const Divider = ({ title }) => (
  <div className={classes.dividerContainer}>
    <span>{title}</span>
  </div>
);

Divider.propTypes = {
  title: PropTypes.string.isRequired,
};

Divider.defaultProps = {
  title: '',
};

export { Divider };
